<div
  *ngIf="loading$ | async"
  [ngClass]="(transparentOverlay$ | async) ? 'custom-loader-overlay-transparent' : 'custom-loader-overlay'"
>
  <div class="custom-loader-container">
    <div class="custom-loader"></div>
    <div class="loader-message">
      <div>{{ message1$ | async }}</div>
      <div>{{ message2$ | async }}</div>
    </div>
  </div>
</div>